import { ColumnType, ReportColumn } from "@/types/evaluate";

/**
 * Creates a temporary column for the "Add Step" functionality
 * This column has no ID, indicating it hasn't been persisted to the backend yet
 */
export const createTemporaryColumn = (
  reportId: number,
  position: number,
  preexisting: string[] = [],
): ReportColumn => {
  let stepNumber = position + 1;
  let stepName = `Step #${stepNumber}`;

  // Keep incrementing step number if name already exists
  while (preexisting.includes(stepName)) {
    stepNumber += 1;
    stepName = `Step #${stepNumber}`;
  }

  return {
    // No id field means it's not yet created in the backend
    name: stepName,
    column_type: ColumnType.PROMPT_TEMPLATE, // Default to most common type
    configuration: {},
    position,
    report_id: reportId,
    is_part_of_score: false,
    score: null,
  };
};
